import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ColorLens } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import { usePermissionCheck } from "fond/hooks/usePermissionCheck";
import { PermissionLevel, Store } from "fond/types";
import { Actions } from "fond/utils/permissions";

export interface StyleEditorMenuItemProps {
  permissionLevel: PermissionLevel;
  handleClose: () => void;
}

const StyleEditorMenuItem: React.FC<StyleEditorMenuItemProps> = ({ permissionLevel, handleClose }: StyleEditorMenuItemProps) => {
  const versionId = useSelector((state: Store) => state.project.versionId);

  const navigate = useNavigate();
  const canEdit = usePermissionCheck(Actions.PROJECT_EDIT_STYLES, permissionLevel);

  /**
   * Handles the redirection to the style editor
   */
  const handleClick = () => {
    if (canEdit) {
      handleClose();
      navigate(`/styles/${versionId}`);
    }
  };

  return (
    <MenuItem data-testid="styles-editor-button" onClick={handleClick} disabled={!canEdit}>
      <ListItemIcon>
        <ColorLens />
      </ListItemIcon>
      Style Editor
    </MenuItem>
  );
};

export default StyleEditorMenuItem;
